

























































import { fetchReference } from "@/lib/utility/fetch-reference.helper";
import { MrfiktivReferenceGen } from "@/services/mrfiktiv/v1/data-contracts";
import { BackendResourceEnum, ResourceEnum } from "@/store/enum/authResourceEnum";
import { IRefSuggestion } from "@/store/modules/fleet-aggregation.store";
import { RefTypeMap } from "@/store/modules/refs.store";
import { Component, Prop, Vue } from "vue-property-decorator";
import draggable from "vuedraggable";
import RefsList, { IRefDetail } from "./RefsList.vue";
import Tooltip from "./tooltip.vue";

@Component({
  components: { RefsList, draggable, Tooltip },
  filters: {}
})
export default class RefsSelected extends Vue {
  @Prop()
  private value!: MrfiktivReferenceGen[];

  @Prop({ default: () => [] })
  suggested!: IRefSuggestion[];

  @Prop()
  partnerId!: string;

  @Prop({ default: true })
  showActions!: boolean;

  @Prop({ default: true })
  draggable!: boolean;

  @Prop({ default: true })
  removable!: boolean;

  @Prop({ default: false })
  confirmable!: boolean;

  @Prop({ default: false })
  small!: boolean;

  @Prop({ default: true })
  outlined!: boolean;

  get selected(): MrfiktivReferenceGen[] {
    return this.value;
  }
  set selected(v: MrfiktivReferenceGen[]) {
    this.$emit("input", v);
  }

  get isMobile() {
    return this.$vuetify.breakpoint.xsOnly;
  }

  readonly RefTypeMap = RefTypeMap;

  onChange() {
    this.$emit("input", this.value);
  }

  getRefTypeName(refType: ResourceEnum) {
    if (refType === ResourceEnum.EVENT) {
      return this.$t("common.nouns.appointments");
    }
    return this.$t(`BackendResourceEnum.${refType}`);
  }

  getClickTranslation(refType: ResourceEnum) {
    return this.$t(`common.BackendResourceEnum.click.${refType}`);
  }

  getClickTooltipTranslation(refType: ResourceEnum) {
    return this.$t(`common.BackendResourceEnum.click.tooltip.${refType}`);
  }

  async resolveReference(item: MrfiktivReferenceGen) {
    let found = this.suggested.find((e: IRefSuggestion) => e.ref.id === item.refId)?.ref;
    if (found) return found;

    const module = this.RefTypeMap.get(item.refType as BackendResourceEnum)?.module;
    found = module?.maps?.id?.get(item.refId)?.[0];

    // new paginated base store returns list of items from maps
    if (Array.isArray(found)) {
      found = found[0];
    }

    if (found) return found;

    found = await fetchReference(this.partnerId, item);

    return found;
  }

  removeFromSuggested(item: MrfiktivReferenceGen) {
    const index = this.selected.findIndex(i => i.refId === item.refId && item.refType === i.refType);
    this.selected.splice(index, 1);
    this.$forceUpdate();
    this.$emit("removed", item);
  }

  goToDetail(ref: MrfiktivReferenceGen) {
    if (this.$listeners.openDetail) {
      this.$emit("openDetail", ref);
      return undefined;
    }

    const referenceList = this.$refs["reference" + ref.refId];
    if (!referenceList) {
      return;
    }

    const reference = referenceList[0] as IRefDetail<any>;
    if (!reference?.goToDetail) {
      return;
    }

    reference.goToDetail();
  }
}
